export var REGULAR_IMAGE_SIZE = 20;
export var REGULAR_IMAGE_MODS = [
    "q_auto",
    "c_pad",
    "w_" + REGULAR_IMAGE_SIZE,
    "h_" + REGULAR_IMAGE_SIZE,
];
export var ALT_IMAGE_WIDTH = 88;
export var ALT_IMAGE_HEIGHT = 48;
export var ALT_IMAGE_MODS = [
    "q_auto",
    "f_auto",
    "c_fill",
    "w_" + ALT_IMAGE_WIDTH,
    "h_" + ALT_IMAGE_HEIGHT,
];
//# sourceMappingURL=constants.js.map